import { initialState } from "./initialState";
import {
  API_STATUS,
  CLEAR_API_STATUS,
  DELETE_PDF,
  PRE_PRO_PROJECTS,
  GET_USER_LIST,
  IS_SIGNATURE_UPLOADED_STATUS,
  ASSIGN_USER_API_STATUS,
  VALIDATE_USER_STATUS,
  UPLOADED_TEMPLATE_AND_PARAMETERS,
  UPLOADED_BATCH_PDFS,
  GET_TAGS,
  UPDATE_FILTER,
  GET_UPLOADED_PDF_TAGS,
  GET_COOR_DATA,
  GET_PROJECT_TYPE_LIST,
  GET_PROJECT_TYPE,
  GET_OUTPUT_FORMAT_LIST,
  GET_SHEETS_LIST,
  AUTO_REFRESH,
  SET_SELECTED_FILES_DATA_FOR_PRO_UPDATE,
  OCR_REINITIATE_STATUS,
  RESET_PRO_DATA_FROM_PRE,
  GET_TAGS_USERS_PDFS,
  QC_PARAMETERS_DATA,
  QC_SAVE_MAPPING_STATUS,
  LIST_UPLOADED_FILES_RECORD,
  UPLOADING_IP_OP_FILE_PREVIEW,
  CLONE_API_STATUS,
  SET_BBOX_FROM_DRAW_FROM_PRE,
  HIGHLIGHT_BBOX_IN_PRE,
  GET_INVESTIGATOR_USER_LIST,
  // SAVED_BATCHES_DATA,
} from "./types";

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case API_STATUS:
      return {
        ...state,
        apiStatus: action.payload,
      };
    case DELETE_PDF:
      return {
        deletePdf: action.payload,
      };

    case PRE_PRO_PROJECTS:
      return {
        ...state,
        preProProjects: action.payload,
      };

    case CLEAR_API_STATUS:
      return {
        ...state,
        apiStatus: action.payload,
      };

    case UPLOADED_TEMPLATE_AND_PARAMETERS:
      return {
        ...state,
        uploadedTemplateAndParameters: action.payload,
      };
    case GET_USER_LIST:
      return {
        ...state,
        userList: action.payload.data,
      };
    case IS_SIGNATURE_UPLOADED_STATUS:
      return {
        ...state,
        isSignatureUploaded: action.payload,
      };
    case ASSIGN_USER_API_STATUS:
      return {
        ...state,
        assignUserApiStatus: action.payload,
      };
    case VALIDATE_USER_STATUS:
      return {
        ...state,
        validateUser: action.payload,
      };

    case UPLOADED_BATCH_PDFS:
      return {
        ...state,
        uploadedBatchPdfs: action.payload,
      };

    case GET_TAGS:
      return {
        ...state,
        tags: action.payload,
      };

    case UPDATE_FILTER:
      return {
        ...state,
        type: action.payload,
      };

    case GET_UPLOADED_PDF_TAGS:
      return {
        ...state,
        uploadedPdfAndTags: action.payload,
      };

    case GET_COOR_DATA:
      return {
        ...state,
        coorData: action.payload,
      };
    case GET_PROJECT_TYPE_LIST:
      return {
        ...state,
        drugType: action.payload,
      };
    case GET_PROJECT_TYPE:
      return {
        ...state,
        folderType: action.payload.data,
      };
    case GET_SHEETS_LIST:
      return {
        ...state,
        sheetNames: action.payload,
      };
    case GET_OUTPUT_FORMAT_LIST:
      return {
        ...state,
        outpuFormat: action.payload.data,
      };
    case AUTO_REFRESH:
      return {
        ...state,
        autoRefresh: action.payload,
      };
    case SET_SELECTED_FILES_DATA_FOR_PRO_UPDATE:
      return {
        ...state,
        selectedFilesDataForProUpdate: action.payload,
      };
    case OCR_REINITIATE_STATUS:
      return {
        ...state,
        ocrReinitiateStatus: action.payload,
      };

    case RESET_PRO_DATA_FROM_PRE:
      return {
        ...state,
        resetProDataFromPreResponse: action.payload,
      };
    case GET_TAGS_USERS_PDFS:
      return {
        ...state,
        tagsUsersAndPdfs: action.payload,
      };

    // case GET_QC_TEMPLATE_FORMAT:
    //   return {
    //     ...state,
    //     qcFormat: action.payload,
    //   };
    // case SAVED_BATCHES_DATA:
    //   return {
    //     ...state,
    //     savedBatchesData: action.payload,
    //   };

    case QC_PARAMETERS_DATA:
      return {
        ...state,
        qcParametersData: action?.payload,
      };

    case QC_SAVE_MAPPING_STATUS:
      return {
        ...state,
        qcSaveAPiStatus: action.payload,
      };

    case LIST_UPLOADED_FILES_RECORD:
      return {
        ...state,
        uploadedFilesList: action.payload,
      };

    case UPLOADING_IP_OP_FILE_PREVIEW:
      return {
        ...state,
        ipOpFileUrlForPreview: action?.payload,
      };

    case CLONE_API_STATUS:
      return {
        ...state,
        cloneApiStatus: action?.payload,
      };
    case GET_INVESTIGATOR_USER_LIST:
      return {
        ...state,
        investigatorUserList: action?.payload.data,
      };

    case SET_BBOX_FROM_DRAW_FROM_PRE:
      return {
        ...state,
        bboxFromDrawFromPre: action?.payload,
      };

    case HIGHLIGHT_BBOX_IN_PRE:
      return {
        ...state,
        highlightBboxInPre: action?.payload,
      };

    default:
      return state;
  }
};

export default reducer;
